export enum AgentioMethod {
  AgentioConversion = 'AgentioConversion',
  Init = 'initAgentioPixel',
}

export enum AgentioEvent {
  Lead = 'lead',
  AddToCart = 'add_to_cart',
  Purchase = 'purchase',
}

export interface AgentioEventProperties extends CustomEventInit {
  detail: {
    conversionType: AgentioEvent;
  };
}
